module.exports = __webpack_public_path__ + "static/media/meatballs-menu-icon.d54c36d2.svg";